import Organization from "./Organization";
import {ResourceOwnerType} from "./ResourceOwnerType";

export enum VulViewManagementKind {
    MANUAL = "MANUAL",
    INTEREST = "INTEREST",
    ALL_INTERESTS = "ALL_INTERESTS"
}

class VulView {
    constructor(
        public id?: string,
        public name?: string,
        public description?: string,
        public query?: string,
        public importedAt?: Date,
        public owner?: ResourceOwnerType,
        public organization?: Organization,
        public tags?: string[],
        public interestId?: string,
        public managementKind?: VulViewManagementKind,
        public managedByInterest?: boolean) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const vulView = new VulView();

        vulView.id = data.id;
        vulView.name = data.name;
        vulView.description = data.description;
        vulView.query = data.query;
        vulView.importedAt = (data.importedAt) ? new Date(data.importedAt) : undefined;
        vulView.owner = data.owner;
        vulView.organization = Organization.fromPOJO(data.organization);
        vulView.tags = data.tags;
        vulView.interestId = data.interestId;
        vulView.managementKind = data.managementKind;
        vulView.managedByInterest = data.managedByInterest;

        return vulView;
    }

}

export function vulViewSystemFirstComparator(a: VulView, b: VulView) {
    if (a.owner === ResourceOwnerType.SYSTEM && b.owner === ResourceOwnerType.SYSTEM) {
        return 0;
    }

    if (a.owner === ResourceOwnerType.SYSTEM && b.owner === ResourceOwnerType.ORGANIZATION) {
        return -1;
    }

    if (a.owner === ResourceOwnerType.ORGANIZATION && b.owner === ResourceOwnerType.SYSTEM) {
        return 1;
    }

    return a.name.localeCompare(b.name);
}

export function vulViewSystemLastComparator(a: VulView, b: VulView) {
    if (a.owner === ResourceOwnerType.ORGANIZATION && b.owner === ResourceOwnerType.ORGANIZATION) {
        return 0;
    }

    if (a.owner === ResourceOwnerType.ORGANIZATION && b.owner === ResourceOwnerType.SYSTEM) {
        return -1;
    }

    if (a.owner === ResourceOwnerType.SYSTEM && b.owner === ResourceOwnerType.ORGANIZATION) {
        return 1;
    }

    return a.name.localeCompare(b.name);
}

export function isManagedVulView(vulView?: VulView) {
    return !!vulView && (
        vulView.managementKind === VulViewManagementKind.INTEREST
        || vulView.managementKind === VulViewManagementKind.ALL_INTERESTS
        || vulView.managedByInterest === true
    );
}

export default VulView;
